import React from 'react';
import { Typography, Box, Checkbox, FormControlLabel, FormHelperText, TextField, Button } from "@mui/material";
import { GOALS_OPTIONS } from '../../constants/steps';

const Goals = ({ formData, foodTypeError, goalsSubstep = 0, onFormChange, onFoodTypeToggle, onNext }) => {
  // Handle form field changes
  const handleChange = (field, value) => {
    if (onFormChange) {
      onFormChange(field, value);
    }
  };

  // Handle food type toggles with improved event handling
  const handleFoodTypeToggle = (type, e) => {
    if (e) {
      // just stop the click from bubbling up, don't prevent default
      e.stopPropagation();
    }

    if (onFoodTypeToggle) {
      console.log(`Toggling food type: ${type}`);
      console.log(`Current food types: ${formData.foodTypes}`);
      onFoodTypeToggle(type);
    }
  };

  // Food Type (substep 0)
  if (goalsSubstep === 0) {
    return (
      <>
        <Typography variant="h6" gutterBottom sx={{ mb: 0, fontWeight: 500 }} color={foodTypeError ? 'error' : 'textPrimary'}>
          What kind of food would you like to offer your cat?
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
          Required
        </Typography>
        <div className="food-type-options">
          {['Dry', 'Wet'].map(type => {
            const checkboxId = `food-type-${type.toLowerCase()}`;
            const isSelected = Array.isArray(formData.foodTypes) && formData.foodTypes.includes(type);

            return (
              <div
                key={type}
                className={`food-type-option ${isSelected ? 'selected' : ''}`}
                onClick={(e) => handleFoodTypeToggle(type, e)}
              >
                <img
                  src={`/icons/${type.toLowerCase()}-food.png`}
                  alt={`${type} Food`}
                  className="food-type-image"
                />
                <div className="food-type-label-container">
                  <span className="food-type-label">
                    {type} Food
                  </span>
                </div>
              </div>
            );
          })}
        </div>
        {foodTypeError && <FormHelperText error sx={{ mt: 1 }}>Please select at least one food type.</FormHelperText>}
      </>
    );
  }

  // Diet Goals (substep 1)
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
        <Box>
          <Typography variant="h6" gutterBottom sx={{ mb: 0, fontWeight: 500 }}>
            What are your goals for your cat's diet?
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Optional
          </Typography>
        </Box>
        <Button 
          variant="text" 
          color="primary" 
          onClick={onNext}
          sx={{ textTransform: 'none' }}
        >
          Skip
        </Button>
      </Box>
      <div className="goals-selection">
        {GOALS_OPTIONS.map(({ key, label }) => {
          const isSelected = Array.isArray(formData.goals) && formData.goals.includes(key);
          
          return (
            <div
              key={key}
              className={`texture-option-simple ${isSelected ? 'selected' : ''}`}
              onClick={() => {
                handleChange(
                  'goals',
                  isSelected
                    ? formData.goals.filter(i => i !== key)
                    : [...(formData.goals || []), key]
                );
              }}
            >
              <div className="texture-container-simple">
                <span className="texture-label">
                  {label}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      <TextField
        label="Any other goals or concerns?"
        variant="outlined"
        fullWidth
        multiline
        rows={3}
        sx={{ mt: 2 }}
        value={formData.other || ''}
        onChange={e => handleChange('other', e.target.value)}
      />
    </>
  );
};

export default Goals;